import React from "react";

const LoadableDocumentVisualize = React.lazy(
  () => import("./document-visualize")
);

export default LoadableDocumentVisualize;
